import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Filter } from '@docpath/linces-angular-components/common';
import { Table } from '@docpath/webcomponents';
import { Subscription } from 'rxjs';

import { AlertRulesHeaderComponent } from './components/header/alert-rules-header.component';
import { AlertRulesTableComponent } from './components/table/alert-rules-table.component';
import { AlertRulesTableService } from './components/table/alert-rules-table.service';
import { AlertRule } from './models/alert-rule';
import { AlertRulesService } from './services/alert-rules.service';

@Component({
    selector: 'app-configuration-alert-rules',
    templateUrl: './alert-rules.component.html',
    standalone: true,
    imports: [AlertRulesHeaderComponent, AlertRulesTableComponent]
})
export class AlertRulesComponent implements OnInit, OnDestroy {

    private table?: Table;
    private ruleChangedSubscription?: Subscription;
    selectedRule: AlertRule[] = [];
    filters: Filter[] = [];

    private readonly alertRulesTableService = inject(AlertRulesTableService);
    private readonly alertRulesService = inject(AlertRulesService);

    ngOnInit(): void {
        if (!this.ruleChangedSubscription) {
            this.ruleChangedSubscription = this.alertRulesService.alertRuleChanged.subscribe(() => this.refreshAlertRules());
        }
    }

    ngOnDestroy(): void {
        if (this.ruleChangedSubscription) {
            this.ruleChangedSubscription.unsubscribe();
        }
    }

    onCheckChange(): void {
        if (this.table) {
            this.selectedRule = this.alertRulesTableService.getSelectedAlertRule(this.table);
        }
    }

    getTable(): Table | undefined {
        return this.table;
    }

    onTableLoaded(table: Table): void {
        this.table = table;
    }

    onFilterChange(filters: Filter[]): void {
        this.filters = filters;
    }

    private refreshAlertRules(): void {
        this.alertRulesTableService.loadAlertRules(this.filters, 1);
    }

    getSelectedAlertRulesCount(): number {

        if (this.table) {
            const alertRules = this.alertRulesTableService.getSelectedAlertRule(this.table);

            return alertRules.length;
        }

        return 0;

    }

    getSelectedAlertRules(): AlertRule | undefined {

        if (this.table) {
            const alertRule = this.alertRulesTableService.getSelectedAlertRule(this.table);

            return alertRule.length === 1 ? alertRule[0] : undefined;
        }

        return undefined;

    }

}